import { render, staticRenderFns } from "./TruckOrderDetail.vue?vue&type=template&id=1c8bd124&scoped=true&"
import script from "./TruckOrderDetail.vue?vue&type=script&lang=js&"
export * from "./TruckOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./TruckOrderDetail.vue?vue&type=style&index=0&id=1c8bd124&scoped=true&lang=css&"
import style1 from "./TruckOrderDetail.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8bd124",
  null
  
)

export default component.exports